import React from 'react';
import { Box, Typography } from 'vindi-ds-components';
import Header from '../../components/header';

const FormHeader = ({ headerTitle }) => (
  <>
    <Header headerTitle={headerTitle} />
    <Box margin='2em 0 1.5em 0'>
      <Typography variant='subtitle1' component='h2'>Dados</Typography>
    </Box>
  </>
);

export default FormHeader;
